import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Segments} from './models/segments';
import {map} from 'rxjs/operators';
import {Router} from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class TransportationService {

  constructor(private http: HttpClient,
              private route: Router) {
  }

  private jsonURL = 'assets/segments2.json';

  public getAllTransportations(): Observable<any> {
    return this.http.get(this.jsonURL);
  }

  getTransportation(key: string): Observable<any> {
    return this.getAllTransportations().pipe(
      map((segments: Segments[]) => segments.find(s => s.key === key))
    );
  }

// find renvoie le premier élément qu'il trouve alors que filter renvoie tous les éléments qui
  // correspondent à la condition, il ramène donc un tableau contrairement à find

  getProducts(title: string, keyZone: string): Observable<any> {
    return this.getTransportation(title).pipe(
      map(res => res.zones.find(result => result.key === keyZone)));

  }


  getDetailsProduct(title: string, keyZone: string, keyProduct): Observable<any> {
    return this.getProducts(title, keyZone).pipe(
      map(res => res.products.find(result => result.key === keyProduct))
    );
  }


}
